import { consume, ContextType } from '@lit/context';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { contexts } from '../contexts.js';
import { PageAdministrationAudit } from '../page-administration-audit.js';
import { PageAdministrationBilling } from '../page-administration-billing.js';
import { PageAdministrationQueues } from '../page-administration-queues.js';
import { PageAdministrationUsage } from '../page-administration-usage.js';
import { PageAdministrationUsers } from '../page-administration-users.js';
import { PageUserOrganizations } from '../page-user-organizations.js';
import { PageUserProjects } from '../page-user-projects.js';
import { PageUserSettings } from '../page-user-settings.js';

@customElement('user-header')
class UserHeader extends LitElement {
  @consume({ context: contexts.user, subscribe: true }) @state() private _user?: ContextType<typeof contexts.user>;
  @consume({ context: contexts.auditLogRecentCount, subscribe: true }) @state() private _auditLogRecentCount?: ContextType<typeof contexts.auditLogRecentCount>;
  @property({}) submenu: string = 'projects';

  override render() {
    const auditLogRecentCount = this._auditLogRecentCount ?? 0;
    return html`
      <app-header .customTitle=${'Dashboard'}>
        <app-header-submenu
          href=${PageUserProjects.url()}
          ?active=${this.submenu === 'projects'}
        ><sl-icon src='/repo.svg'></sl-icon>Projects</app-header-submenu>
        <app-header-submenu
          href=${PageUserOrganizations.url()}
          ?active=${this.submenu === 'organizations'}
        ><sl-icon name=buildings></sl-icon>Organizations</app-header-submenu>
        <app-header-submenu
          href=${PageUserSettings.url()}
          ?active=${this.submenu === 'settings'}
        ><sl-icon name=gear></sl-icon>Settings</app-header-submenu>
        ${this._user?.isSuperUser ? html`
          <app-header-submenu
            href=${PageAdministrationUsage.url()}
            ?active=${this.submenu === 'admin-usage'}
          ><sl-icon name=speedometer2></sl-icon>Usage</app-header-submenu>
          <app-header-submenu
            href=${PageAdministrationUsers.url()}
            ?active=${this.submenu === 'admin-users'}
          ><sl-icon name=people></sl-icon>Users</app-header-submenu>
          <app-header-submenu
            href=${PageAdministrationQueues.url()}
            ?active=${this.submenu === 'admin-queues'}
          ><sl-icon name=list-task></sl-icon>Jobs</app-header-submenu>
          <app-header-submenu
            href=${PageAdministrationBilling.url()}
            ?active=${this.submenu === 'admin-billing'}
          ><sl-icon name=credit-card></sl-icon>Product Plans</app-header-submenu>
          <app-header-submenu
            href=${PageAdministrationAudit.url()}
            ?active=${this.submenu === 'admin-audit'}
          ><sl-icon name=clipboard-check></sl-icon>Audit Log${auditLogRecentCount > 0 ? html`
            <sl-tooltip content=${`${auditLogRecentCount} action${auditLogRecentCount > 1 ? 's' : ''} in the last 24 hours`}>
              <sl-tag size=small pill>${auditLogRecentCount}</sl-tag>
            </sl-tooltip>
          ` : nothing}</app-header-submenu>
        ` : nothing}
      </app-header>
    `;
  }

  static styles = css`
    :host {
      display: block;
    }

    sl-tag::part(base) {
      height: 16px;
    }
  `;
}
